import { timeTrackerTitle } from '@repo/themes/styled-system/recipes';
import { Button } from './Button';
import { useState } from 'react';
import React from 'react';

const classes = timeTrackerTitle();

const TimeTrackerContainer = ({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element => {
  return <div className={classes.root}>{children}</div>;
};

const TimeTrackerMessage = ({ children }: { children: React.ReactNode }) => {
  return <h4 className={classes.message}>{children}</h4>;
};

const TimeTrackerAction = ({
  action,
  children,
}: {
  action: () => Promise<void>;
  children: React.ReactNode;
}) => {
  const [disabled, setDisabled] = useState(false);

  const handleClick = async () => {
    setDisabled(true);
    await action();
    setDisabled(false);
  };
  return (
    <Button onClick={handleClick} disabled={disabled}>
      {children}
    </Button>
  );
};

TimeTrackerContainer.displayName = 'TimeTracker.Container';
TimeTrackerMessage.displayName = 'TimeTracker.Message';
TimeTrackerAction.displayName = 'TimeTracker.Action';

export default {
  Container: TimeTrackerContainer,
  Message: TimeTrackerMessage,
  Action: TimeTrackerAction,
};
